import { changeEvent, checkFormValidity } from "../../form-store/action-types";

export const onChangeEvent = (name, value) => dispatch => {
  let obj = {
    key: name,
    value,
  };
  dispatch(changeEvent(obj));
  dispatch(checkFormValidity());
};
